module.exports = __webpack_public_path__ + "media/images/ui__textArrowLeft-af2a430be2b91f97cd91daade994fb91.png";